import { Controller } from '@hotwired/stimulus'
import { loadFilePond } from '../models/filepond_loader'

let uploadProcess = {}
const csrfToken = document.getElementsByName('csrf-token')[0].content
export default class MediaController extends Controller {
  static targets = ['multiple', 'single', 'profileimage', 'galleryfolder']
  static values = {
    user: Object,
    documents: Object,
    img: Object
  }
  async getFilePond() {
    return this.FilePond || (this.FilePond = await loadFilePond())
  }

  async defaultTargetConnected() {
    const FilePond = await this.getFilePond()
    let params = this.documentsValue
    this.pond = FilePond.create(this.element, {
      storeAsFile: true,
      // className: 'h-25',
      // height: '50px',
      imagePreviewHeight: 180,
      credits: false,
      itemInsertLocation: 'bottom',
      files: params.files,
      onaddfile: (e) => {
        this.isValid()
      },
      beforeRemoveFile: async (item) => {
        const result = await this.showAlert(
          "Confirmation",
          "Are you sure you want to remove this file?",
          "warning"
        )

        if (result.isConfirmed) {
          this.isValid()
          return true
        }

        return false
      }
    })
  }

  async singleTargetConnected() {
    const FilePond = await this.getFilePond()
    let params = this.userValue
    let width = ''
    let height = 100

    if (params.file_type === 'nft_thumbnail') {
      width = 294
      height = 260
    } else if (params.file_type === 'user_thumbnail') {
      width = 500
      height = 500
    }

    let options = {
      labelIdle:
        params.file_type === 'nft_thumbnail'
          ? '<p class="bg-clip-text text-transparent text-gradient-orange fs-28">Upload thumbnail to preview NFT</p>'
          : '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
            '                          <path d="M27.625 0.5H4.375C2.23886 0.5 0.5 2.23886 0.5 4.375V27.625C0.5 29.7611 2.23886 31.5 4.375 31.5H27.625C29.7611 31.5 31.5 29.7611 31.5 27.625V4.375C31.5 2.23886 29.7611 0.5 27.625 0.5ZM4.375 3.75H27.625C27.9684 3.75 28.25 4.03164 28.25 4.375V17.6819L23.3166 12.7484C23.0139 12.4457 22.6021 12.272 22.168 12.272H22.1635C21.732 12.272 21.3125 12.4441 21.0077 12.7588C21.007 12.7594 21.0064 12.7601 21.0058 12.7607L14.8866 18.9749L12.5241 16.6214C12.524 16.6214 12.5239 16.6213 12.5239 16.6212C12.2297 16.3272 11.8326 16.1549 11.4122 16.1454C10.9113 16.0855 10.4726 16.3671 10.2135 16.6379L3.75 23.2378V4.375C3.75 4.03164 4.03164 3.75 4.375 3.75ZM4.375 28.25C4.11176 28.25 3.88251 28.0792 3.79536 27.8369L11.3906 20.0791L19.5981 28.25H4.375ZM27.625 28.25H24.2015L17.1896 21.2661L22.1752 16.2043L28.25 22.2776V27.625C28.25 27.9684 27.9684 28.25 27.625 28.25Z" fill="white" stroke="#5452AD"/>\n' +
            '                          <path d="M11.302 13.2765C12.8556 13.2765 14.115 12.0171 14.115 10.4635C14.115 8.90992 12.8556 7.6505 11.302 7.6505C9.74844 7.6505 8.48901 8.90992 8.48901 10.4635C8.48901 12.0171 9.74844 13.2765 11.302 13.2765Z" fill="white" stroke="#5452AD"/>\n' +
            '                        </svg> ',
      storeAsFile: true,
      imagePreviewWidth: width,
      labelTapToCancel: '',
      imagePreviewHeight: height,
      filePosterHeight: height,
      filePosterMaxHeight: height
    }
    const pond = FilePond.create(this.element, {
      beforeRemoveFile: (file) => {
        return Swal.fire({
          customClass: {
            popup:
              'swal-popup alert-sm-bg align-items-center justify-content-center w-100',
            htmlContainer: 'text-black-paint text-white'
          },
          animation: false,
          title: 'Do you want to delete this file?',
          showCancelButton: true,
          confirmButtonText: 'Delete',
          itemInsertLocation: 'bottom',
          cancelButtonText: 'Cancel',
          confirmButtonColor: '#d56859',
          showLoaderOnConfirm: true
        }).then((result) => {
          if (result.isConfirmed) {
            pond.removeFile(file)
            if (params.file_type != 'nft_thumbnail') {
              this.delete_data(params.remove_url, {
                img_id: file.file['id'],
                image_column: file.file['column_name']
              })
            }
          }
        })
      }
    })
    if (params.file_type == 'nft_thumbnail') {
      pond.on('addfile', () => {
        if (/Mobi|Android|iPhone|iPad/i.test(navigator.userAgent)) {
          document.getElementById('nft_image').scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          })
        }
        const err = document.querySelector('.required-error label.error')
        if (err) err.remove()
      })
    }
    if (params.name != '') {
      options['files'] = [
        {
          source: params?.source,
          options: {
            type: 'local',
            file: {
              name: params.name,
              size: params.size,
              type: params.type,
              id: params.id,
              column_name: params.column_name
            },
            metadata: {
              poster: params.url
            }
          }
        }
      ]
    }
    pond.setOptions(options)
  }

  async profileimageTargetConnected() {
    const FilePond = await this.getFilePond()
    let params = this.userValue
    let options = {
      labelIdle:
        params.file_type === 'user_profile'
          ? '<svg width="50" height="50" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
            '<path d="M27.625 0.5H4.375C2.23886 0.5 0.5 2.23886 0.5 4.375V27.625C0.5 29.7611 2.23886 31.5 4.375 31.5H27.625C29.7611 31.5 31.5 29.7611 31.5 27.625V4.375C31.5 2.23886 29.7611 0.5 27.625 0.5ZM4.375 3.75H27.625C27.9684 3.75 28.25 4.03164 28.25 4.375V17.6819L23.3166 12.7484C23.0139 12.4457 22.6021 12.272 22.168 12.272H22.1635C21.732 12.272 21.3125 12.4441 21.0077 12.7588C21.007 12.7594 21.0064 12.7601 21.0058 12.7607L14.8866 18.9749L12.5241 16.6214C12.524 16.6214 12.5239 16.6213 12.5239 16.6212C12.2297 16.3272 11.8326 16.1549 11.4122 16.1454C10.9113 16.0855 10.4726 16.3671 10.2135 16.6379L3.75 23.2378V4.375C3.75 4.03164 4.03164 3.75 4.375 3.75ZM4.375 28.25C4.11176 28.25 3.88251 28.0792 3.79536 27.8369L11.3906 20.0791L19.5981 28.25H4.375ZM27.625 28.25H24.2015L17.1896 21.2661L22.1752 16.2043L28.25 22.2776V27.625C28.25 27.9684 27.9684 28.25 27.625 28.25Z" fill="white" stroke="#5452AD"/>\n' +
            '<path d="M11.302 13.2765C12.8556 13.2765 14.115 12.0171 14.115 10.4635C14.115 8.90992 12.8556 7.6505 11.302 7.6505C9.74844 7.6505 8.48901 8.90992 8.48901 10.4635C8.48901 12.0171 9.74844 13.2765 11.302 13.2765Z" fill="white" stroke="#5452AD"/>\n' +
            '</svg>'
          : ' <span class="btn button-md bg-image-btn bg-blue-img-btn scale-hover mb-4 py-4 mt-n5 ms-auto">\n' +
            '  <span class="text-black d-block p-font-bold">UPLOAD FROM COMPUTER</span>\n' +
            '  </span>',
      storeAsFile: true,
      imagePreviewHeight: 100,
      // imageCropAspectRatio: '1:1',
      imageResizeTargetWidth: 100,
      itemInsertLocation: 'bottom',
      imageResizeTargetHeight: 100,
      labelTapToCancel: '',
      stylePanelLayout:
        params.file_type === 'user_profile' ? 'compact circle' : '',
      styleLoadIndicatorPosition: 'center bottom',
      styleButtonRemoveItemPosition:
        params.file_type === 'user_profile' ? 'center bottom' : ''
    }
    const pond = FilePond.create(this.element, {
      beforeRemoveFile: this.createBeforeRemoveHandler(params)
    })
    if (params.name != '') {
      options['files'] = [
        {
          options: {
            type: 'local',
            file: {
              name: params.name,
              size: params.size,
              type: params.type,
              column_name: params.column_name
            },
            metadata: {
              poster: params.url
            }
          }
        }
      ]
    }
    pond.setOptions(options)
  }

  async multipleTargetConnected() {
    const FilePond = await this.getFilePond()
    let params = this.documentsValue
    let element = this.multipleTarget
    let labelIdle = ''
    if ($(element).attr('data-media-label') === undefined) {
      labelIdle =
        '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
        '<path d="M27.625 0.5H4.375C2.23886 0.5 0.5 2.23886 0.5 4.375V27.625C0.5 29.7611 2.23886 31.5 4.375 31.5H27.625C29.7611 31.5 31.5 29.7611 31.5 27.625V4.375C31.5 2.23886 29.7611 0.5 27.625 0.5ZM4.375 3.75H27.625C27.9684 3.75 28.25 4.03164 28.25 4.375V17.6819L23.3166 12.7484C23.0139 12.4457 22.6021 12.272 22.168 12.272H22.1635C21.732 12.272 21.3125 12.4441 21.0077 12.7588C21.007 12.7594 21.0064 12.7601 21.0058 12.7607L14.8866 18.9749L12.5241 16.6214C12.524 16.6214 12.5239 16.6213 12.5239 16.6212C12.2297 16.3272 11.8326 16.1549 11.4122 16.1454C10.9113 16.0855 10.4726 16.3671 10.2135 16.6379L3.75 23.2378V4.375C3.75 4.03164 4.03164 3.75 4.375 3.75ZM4.375 28.25C4.11176 28.25 3.88251 28.0792 3.79536 27.8369L11.3906 20.0791L19.5981 28.25H4.375ZM27.625 28.25H24.2015L17.1896 21.2661L22.1752 16.2043L28.25 22.2776V27.625C28.25 27.9684 27.9684 28.25 27.625 28.25Z" fill="white" stroke="#5452AD"/>\n' +
        '<path d="M11.3013 13.2765C12.8549 13.2765 14.1143 12.0171 14.1143 10.4635C14.1143 8.90992 12.8549 7.6505 11.3013 7.6505C9.7477 7.6505 8.48828 8.90992 8.48828 10.4635C8.48828 12.0171 9.7477 13.2765 11.3013 13.2765Z" fill="white" stroke="#5452AD"/>\n' +
        '</svg>'
    } else if (params.file_type === 'attachment') {
      labelIdle =
        '<img class="img img-fluid" width="150" src=\'' +
        params.label_img +
        "'/>"
    }

    let options = {
      storeAsFile: true,
      // filePosterHeight: 100,
      // mediaPreviewHeight: 100,
      // filePosterMaxHeight: 100,
      // imagePreviewHeight: 100,
      labelTapToCancel: '',
      imageResizeTargetWidth: 200,
      itemInsertLocation: 'bottom',
      // imageResizeTargetHeight: 200,
      allowFileSizeValidation: true,
      maxFileSize: '50MB',
      imagePreviewHeight: 180,
      credits: false,
    }
    const pond = FilePond.create(this.element, {
      beforeRemoveFile: this.createBeforeRemoveHandler(params)
    })
    this.pond = pond
    if (params.files !== '') {
      options['files'] = params.files
      pond.on(
        'removefile',
        function (error, file) {
          let id = file.file['id']
          let img_id = file.file['img_id']
          let image_column = file.file['image_column']
          this.delete_data(params.remove_url, {
            img_id: img_id,
            id: id,
            image_column: image_column
          })
          this.isValid()
        }.bind(this)
      )
      pond.on(
        'addfile',
        function (e) {
          if ($(this.element).attr('data-post') === 'true') {
            $('.post_submit').removeClass('disabled')
            $('.add_post,.add_child_post,.progress-ring').removeClass('d-none')
          }
          this.isValid()
        }.bind(this)
      )
    }
    pond.setOptions(options)
  }

  async galleryfolderTargetConnected(e) {
    const FilePond = await this.getFilePond()
    let params = this.documentsValue
    let image = this.galleryfolderTarget.dataset?.imgValue
    this.pond = FilePond.create(this.element, {
      labelIdle:
        '<img class="img img-fluid w-100" width="340" src=\'' + image + "'/>",
      // imagePreviewHeight: 100,
      // filePosterHeight: 100,
      // labelTapToCancel: '',
      // filePosterMaxHeight: 100,
      storeAsFile: true,
      itemInsertLocation: 'bottom',
      files: params.files,
      imagePreviewHeight: 180,
      credits: false,
      onaddfile: (e) => {
        this.isValid()
      },
      beforeRemoveFile: this.createBeforeRemoveHandler(params)
    })
  }

  delete_data(remove_url, item_data) {
    let id = item_data['img_id']
    if (id) {
      $.ajax({
        url: remove_url,
        type: 'POST',
        datatype: 'Script',
        headers: {
          'X-CSRF-Token': csrfToken
        },
        data: {
          column_names: item_data['image_column'],
          id: item_data['img_id']
        },
        success: function (result) {}
      })
    }
  }

  isValid() {
    const $form = $(this?.pond?.element?.firstChild)?.closest('form')
    if ($form?.valid()) {
      $form.find("[type='submit']").attr('disabled', false)
    } else {
      $form.find("[type='submit']").attr('disabled', true)
    }
  }

  createBeforeRemoveHandler(params = {}, pond = null) {
    return async (file) => {
      const confirmed = await confirmFileRemoval()

      if (!confirmed) {
        return false
      }

      this.isValid()

      if (
        params.remove_url &&
        file?.file?.id &&
        params.file_type !== 'nft_thumbnail'
      ) {
        this.delete_data(params.remove_url, {
          img_id: file.file.id,
          image_column: file.file.column_name
        })
      }

      return true
    }
  }

  showAlert(title, message, icon) {
    return Swal.fire({
      customClass: {
        popup: 'swal-popup alert-sm-bg align-items-center justify-content-center w-100',
        htmlContainer: 'text-black-paint text-white'
      },
      animation: false,
      title: title,
      text: message,
      icon: icon,
      confirmButtonText: "OK",
      showCancelButton: true,
      cancelButtonText: "Cancel"
    });
  }
}
